import React from 'react'
import { Box, Text } from 'grommet'
import InputButton from '../Button/InputButton'

const InputMethod = ({ inputMethod, setInputMethod }) => {
  return (
    <Box gap=".5rem">
      <Text>Input Method: </Text>
      <Box direction="row" gap="1rem" justify="center">
        <InputButton
          active={inputMethod === 'By Range'}
          onClick={() => {
            setInputMethod('By Range')
          }}
        >
          By Range
        </InputButton>
        <InputButton
          active={inputMethod === 'By Formula'}
          onClick={() => {
            setInputMethod('By Formula')
          }}
        >
          By Formula
        </InputButton>
      </Box>
    </Box>
  )
}

export default InputMethod
